import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const TraccUsageSlice = createSlice({
  name: SliceKeys.TRACC_Usage,
  initialState: { pagination: tablePaginationInitialValue },
  reducers: {
    setTraccUsagePageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setTraccUsagePageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setTraccUsageSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearTraccUsageSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
    },
    setTraccUsageSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
  },
});

export const { setTraccUsagePageSize, setTraccUsagePageIndex, setTraccUsageSearchColumn, clearTraccUsageSearchColumn, setTraccUsageSortColumn } =
  TraccUsageSlice.actions;

export const selectTraccUsagePagination = createSelector(
  (state: RootState) => state.traccUsage.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setTraccUsagePageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setTraccUsagePageIndex,
    },
    sort,
    search: { object: search, onChange: setTraccUsageSearchColumn, onClear: clearTraccUsageSearchColumn },
  }),
);
export const selectTraccUsageQuery = createSelector(
  (state: RootState) => state.traccUsage.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default TraccUsageSlice.reducer;
